import React from 'react';
import PageMenu from './PageMenu';

function MenuFind(props) {
  return (
    <PageMenu
      {...props}
      title="Find Your Home"
      items={[
        {
          name: 'community-map',
          title: 'Community Map & Lots',
          keepParams: true,
        },
        {
          name: 'homes',
          title: 'Quick Move-In Homes',
          keepParams: true,
        },
        {
          name: 'plans',
          title: 'Available Plans',
          keepParams: true,
        },
        {
          name: 'model-homes',
          title: 'Model Homes Showcase',
          keepParams: true,
        },
      ]}
    />
  );
}

export default MenuFind;



// WEBPACK FOOTER //
// ./src/components/MenuFind.js